import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import ProductList from './widgets/ProductList'
import {
  HOME_PAGE_LOADED,
  HOME_PAGE_UNLOADED,
  REDIRECT
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'
import _ from 'lodash'

const mapStateToProps = state => ({
  ...state.home,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: HOME_PAGE_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: HOME_PAGE_UNLOADED }),
  onRedirect: () =>
    dispatch({ type: REDIRECT })
})

class Home extends React.Component {
  componentWillMount() {
    if (this.props.currentUser) {
      const payload = Promise.all([
        agent.Categories.getCategories(this.props.currentUser.key),
        agent.Products.getProducts(this.props.currentUser.key)
      ])
      this.props.onLoad(payload);
    } else {
      store.dispatch(push('/login'))
      this.props.onRedirect()
    }
  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  render() {
    if (!this.props.categories) {
      return (
        <Loading />
      )
    }
    let categories = this.props.categories
    categories = _.orderBy(categories, ['name'], ['asc'])
    let products = this.props.products
    return (
      <div>
        <Header selected={'product'} />
        <div id="main">
          <div id="main-wrap">
            <div id="content">
              {
                categories.map(category => {
                  let cate_products = _.filter(products, { category_key: category.key })
                  cate_products = _.orderBy(cate_products, ['name'], ['asc'])
                  return (
                    <div key={category.key}>
                      <h2>{category.name}</h2>
                      <ProductList data={cate_products} />
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
